import React, { createContext, useState, useCallback, useEffect, useContext } from 'react';
import Web3 from 'web3';
import { Logger, Ocean } from '@oceanprotocol/lib';
import Web3Modal from 'web3modal';
import { Decimal } from 'decimal.js';
import axios from 'axios';
var ProviderStatus;

(function (ProviderStatus) {
  ProviderStatus[ProviderStatus["NOT_AVAILABLE"] = -1] = "NOT_AVAILABLE";
  ProviderStatus[ProviderStatus["NOT_CONNECTED"] = 0] = "NOT_CONNECTED";
  ProviderStatus[ProviderStatus["CONNECTED"] = 1] = "CONNECTED";
})(ProviderStatus || (ProviderStatus = {}));

var ProviderStatus$1 = ProviderStatus;

var getDefaultProviders = function getDefaultProviders() {
  try {
    return Promise.resolve({
      cacheProvider: true
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

function _settle(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }

        value = value.v;
      } else {
        value.o = _settle.bind(null, pact, state);
        return;
      }
    }

    if (value && value.then) {
      value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
      return;
    }

    pact.s = state;
    pact.v = value;
    var observer = pact.o;

    if (observer) {
      observer(pact);
    }
  }
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var getDataTokenPrice = function getDataTokenPrice(ocean, dataTokenAddress, type, poolAddress) {
  try {
    switch (type) {
      case 'pool':
        {
          return Promise.resolve(getFirstPool(ocean, dataTokenAddress, poolAddress)).then(function (cheapestPool) {
            return {
              type: 'pool',
              address: cheapestPool == null ? void 0 : cheapestPool.address,
              value: cheapestPool == null ? void 0 : cheapestPool.price,
              ocean: cheapestPool == null ? void 0 : cheapestPool.ocean,
              datatoken: cheapestPool == null ? void 0 : cheapestPool.datatoken
            };
          });
        }

      case 'exchange':
        {
          return Promise.resolve(getFirstExchange(ocean, dataTokenAddress)).then(function (cheapestExchange) {
            return {
              type: 'exchange',
              address: cheapestExchange == null ? void 0 : cheapestExchange.address,
              value: Number(cheapestExchange == null ? void 0 : cheapestExchange.price)
            };
          });
        }

      default:
        {
          return Promise.resolve(getBestDataTokenPrice(ocean, dataTokenAddress, poolAddress));
        }
    }
  } catch (e) {
    return Promise.reject(e);
  }
};

var getBestDataTokenPrice = function getBestDataTokenPrice(ocean, dataTokenAddress, poolAddress) {
  try {
    return Promise.resolve(getFirstPool(ocean, dataTokenAddress, poolAddress)).then(function (cheapestPool) {
      return Promise.resolve(getCheapestExchange(ocean, dataTokenAddress)).then(function (cheapestExchange) {
        Decimal.set({
          precision: 5
        });
        var cheapestPoolPrice = new Decimal(cheapestPool && cheapestPool.price !== 0 ? cheapestPool.price : 999999999999);
        var cheapestExchangePrice = new Decimal(cheapestExchange && (cheapestExchange == null ? void 0 : cheapestExchange.price) !== 0 ? cheapestExchange.price : 999999999999);

        if (cheapestPoolPrice < cheapestExchangePrice) {
          return {
            type: 'pool',
            address: cheapestPool == null ? void 0 : cheapestPool.address,
            value: cheapestPool == null ? void 0 : cheapestPool.price,
            ocean: cheapestPool == null ? void 0 : cheapestPool.ocean,
            datatoken: cheapestPool == null ? void 0 : cheapestPool.datatoken
          };
        } else {
          return {
            type: 'exchange',
            address: cheapestExchange == null ? void 0 : cheapestExchange.address,
            value: Number(cheapestExchange == null ? void 0 : cheapestExchange.price)
          };
        }
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var getFirstPool = function getFirstPool(ocean, dataTokenAddress, poolAddress) {
  try {
    var _temp7 = function _temp7(_result) {
      return _exit2 ? _result : firstPoolAddress ? Promise.resolve(ocean.pool.getOceanNeeded(firstPoolAddress, '1')).then(function (firstPoolPrice) {
        return Promise.resolve(ocean.pool.getOceanReserve(firstPoolAddress)).then(function (oceanReserve) {
          return Promise.resolve(ocean.pool.getDTReserve(firstPoolAddress)).then(function (dtReserve) {
            if (firstPoolPrice) {
              var priceChars = firstPoolPrice.split('.');
              var numberOfCharsOfPrice = priceChars[0].length;
              if (numberOfCharsOfPrice > 8) firstPoolPrice = '0';
            }

            return {
              address: firstPoolAddress,
              price: Number(firstPoolPrice),
              ocean: Number(oceanReserve),
              datatoken: Number(dtReserve)
            };
          });
        });
      }) : {
        address: '',
        price: 0
      };
    };

    var _exit2;

    var firstPoolAddress = poolAddress;

    var _temp8 = function () {
      if (!poolAddress) {
        return Promise.resolve(ocean.pool.searchPoolforDT(dataTokenAddress)).then(function (tokenPools) {
          if (tokenPools === undefined || tokenPools.length === 0) {
            _exit2 = 1;
            return {
              address: '',
              price: 0
            };
          }

          firstPoolAddress = tokenPools[0];
        });
      }
    }();

    return Promise.resolve(_temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8));
  } catch (e) {
    return Promise.reject(e);
  }
};

var getFirstExchange = function getFirstExchange(ocean, dataTokenAddress) {
  try {
    return Promise.resolve(_catch(function () {
      return Promise.resolve(ocean.fixedRateExchange.searchforDT(dataTokenAddress, '1')).then(function (tokenExchanges) {
        if (tokenExchanges === undefined || tokenExchanges.length === 0) {
          return {
            address: '',
            price: 0
          };
        }

        var tokenExchange = tokenExchanges[0];
        return {
          address: tokenExchange.exchangeID || '',
          price: Number(tokenExchange.fixedRate)
        };
      });
    }, function (err) {
      Logger.log(err);
      return {
        address: '',
        price: 0
      };
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var getCheapestExchange = function getCheapestExchange(ocean, dataTokenAddress) {
  try {
    return Promise.resolve(_catch(function () {
      return Promise.resolve(ocean.fixedRateExchange.searchforDT(dataTokenAddress, '1')).then(function (tokenExchanges) {
        if (tokenExchanges === undefined || tokenExchanges.length === 0) {
          return {
            address: '',
            price: 0
          };
        }

        var cheapestExchangeAddress = tokenExchanges[0].exchangeID;
        var cheapestExchangePrice = new Decimal(tokenExchanges[0].fixedRate);

        for (var _i = 0; _i < tokenExchanges.length; _i++) {
          var decimalExchangePrice = new Decimal(tokenExchanges[_i].fixedRate);

          if (decimalExchangePrice < cheapestExchangePrice) {
            cheapestExchangePrice = decimalExchangePrice;
            cheapestExchangeAddress = tokenExchanges[_i].exchangeID;
          }
        }

        return {
          address: cheapestExchangeAddress || '',
          price: Number(cheapestExchangePrice)
        };
      });
    }, function (err) {
      Logger.log(err);
      return {
        address: '',
        price: 0
      };
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var _Pact = /*#__PURE__*/function () {
  function _Pact() {}

  _Pact.prototype.then = function (onFulfilled, onRejected) {
    var result = new _Pact();
    var state = this.s;

    if (state) {
      var callback = state & 1 ? onFulfilled : onRejected;

      if (callback) {
        try {
          _settle(result, 1, callback(this.v));
        } catch (e) {
          _settle(result, 2, e);
        }

        return result;
      } else {
        return this;
      }
    }

    this.o = function (_this) {
      try {
        var value = _this.v;

        if (_this.s & 1) {
          _settle(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle(result, 1, onRejected(value));
        } else {
          _settle(result, 2, value);
        }
      } catch (e) {
        _settle(result, 2, e);
      }
    };

    return result;
  };

  return _Pact;
}();

function _isSettledPact(thenable) {
  return thenable instanceof _Pact && thenable.s & 1;
}

function _forTo(array, body, check) {
  var i = -1,
      pact,
      reject;

  function _cycle(result) {
    try {
      while (++i < array.length && (!check || !check())) {
        result = body(i);

        if (result && result.then) {
          if (_isSettledPact(result)) {
            result = result.v;
          } else {
            result.then(_cycle, reject || (reject = _settle.bind(null, pact = new _Pact(), 2)));
            return;
          }
        }
      }

      if (pact) {
        _settle(pact, 1, result);
      } else {
        pact = result;
      }
    } catch (e) {
      _settle(pact || (pact = new _Pact()), 2, e);
    }
  }

  _cycle();

  return pact;
}

var getCheapestPool = function getCheapestPool(ocean, dataTokenAddress) {
  try {
    return Promise.resolve(ocean.pool.searchPoolforDT(dataTokenAddress)).then(function (tokenPools) {
      function _temp3() {
        return Promise.resolve(ocean.pool.getOceanReserve(cheapestPoolAddress)).then(function (oceanReserve) {
          return Promise.resolve(ocean.pool.getDTReserve(cheapestPoolAddress)).then(function (dtReserve) {
            return {
              address: cheapestPoolAddress,
              price: Number(cheapestPoolPrice),
              ocean: Number(oceanReserve),
              datatoken: Number(dtReserve)
            };
          });
        });
      }

      if (tokenPools === undefined || tokenPools.length === 0) {
        return {
          address: '',
          price: 0
        };
      }

      var cheapestPoolAddress = tokenPools[0];
      var cheapestPoolPrice = new Decimal(999999999999);

      var _temp2 = function () {
        if (tokenPools) {
          var _temp4 = _forTo(tokenPools, function (i) {
            return Promise.resolve(ocean.pool.getOceanNeeded(tokenPools[i], '1')).then(function (poolPrice) {
              var decimalPoolPrice = new Decimal(poolPrice);

              if (decimalPoolPrice < cheapestPoolPrice) {
                cheapestPoolPrice = decimalPoolPrice;
                cheapestPoolAddress = tokenPools[i];
              }
            });
          });

          if (_temp4 && _temp4.then) return _temp4.then(function () {});
        }
      }();

      return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var getBalance = function getBalance(account) {
  try {
    return Promise.resolve(account.getEtherBalance()).then(function (eth) {
      return Promise.resolve(account.getOceanBalance()).then(function (ocean) {
        return {
          eth: eth,
          ocean: ocean
        };
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var getAccountId = function getAccountId(web3) {
  try {
    return Promise.resolve(web3.eth.getAccounts()).then(function (accounts) {
      return accounts[0];
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var feedback = {
  99: 'Decrypting file URL...',
  0: '1/3 Looking for data token. Buying if none found...',
  1: '2/3 Transfering data token.',
  2: '3/3 Payment confirmed. Requesting access...'
};
var publishFeedback = {
  0: '1/5 Creating datatoken ...',
  2: '2/5 Encrypting files ...',
  4: '3/5 Storing ddo ...',
  6: '4/5 Minting tokens ...',
  8: '5/5 Asset published succesfully'
}; // TODO: do something with this object,
// consumeStep should probably return one of those strings
// instead of just a number

var consumeFeedback = _extends({}, feedback, {
  3: '3/3 Access granted. Consuming file...'
}); // TODO: customize for compute


var computeFeedback = {
  0: '1/3 Ordering asset...',
  1: '2/3 Transfering data token.',
  2: '3/3 Access granted. Starting job...'
};

function getCreatePricingPoolFeedback(dtSymbol) {
  return {
    99: "Minting " + dtSymbol + " ...",
    0: 'Creating pool ...',
    1: "Approving " + dtSymbol + " ...",
    2: 'Approving OCEAN ...',
    3: 'Setup pool ...',
    4: 'Pool created.'
  };
}

function getCreatePricingExchangeFeedback(dtSymbol) {
  return {
    99: "Minting " + dtSymbol + " ...",
    0: 'Creating exchange ...',
    1: "Approving " + dtSymbol + " ...",
    2: 'Fixed exchange created.'
  };
}

function getBuyDTFeedback(dtSymbol) {
  return {
    1: '1/3 Approving OCEAN ...',
    2: "2/3 Buying " + dtSymbol + " ...",
    3: "3/3 " + dtSymbol + " bought."
  };
}

function getSellDTFeedback(dtSymbol) {
  return {
    1: '1/3 Approving OCEAN ...',
    2: "2/3 Selling " + dtSymbol + " ...",
    3: "3/3 " + dtSymbol + " sold."
  };
}

function readFileContent(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onerror = function () {
      reader.abort();
      reject(new DOMException('Problem parsing input file.'));
    };

    reader.onload = function () {
      resolve(reader.result);
    };

    reader.readAsText(file);
  });
}

function isDDO(toBeDetermined) {
  if (toBeDetermined.id) {
    return true;
  }

  return false;
}

function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}

var getAccountPurgatoryData = function getAccountPurgatoryData(address) {
  try {
    return Promise.resolve(axios(purgatoryUrl + "account?address=" + address)).then(function (response) {
      return Promise.resolve(response.data[0]).then(function (responseJson) {
        return {
          address: responseJson == null ? void 0 : responseJson.address,
          reason: responseJson == null ? void 0 : responseJson.reason
        };
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var purgatoryUrl = 'https://market-purgatory.oceanprotocol.com/api/';

function _catch$1(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var OceanContext = createContext({});

function OceanProvider(_ref) {
  var logout = function logout() {
    try {
      // TODO: #67 check how is the proper way to logout
      web3Modal == null ? void 0 : web3Modal.clearCachedProvider();
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }; // TODO: #68 Refetch balance periodically, or figure out some event to subscribe to


  var refreshBalance = function refreshBalance() {
    try {
      var _temp9 = function _temp9(balance) {
        setBalance(balance);
      };

      return Promise.resolve(account ? Promise.resolve(getBalance(account)).then(_temp9) : _temp9(account));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var initialConfig = _ref.initialConfig,
      web3ModalOpts = _ref.web3ModalOpts,
      children = _ref.children;

  var _useState = useState(),
      web3 = _useState[0],
      setWeb3 = _useState[1];

  var _useState2 = useState(),
      web3Provider = _useState2[0],
      setWeb3Provider = _useState2[1];

  var _useState3 = useState(),
      ocean = _useState3[0],
      setOcean = _useState3[1];

  var _useState4 = useState(),
      web3Modal = _useState4[0],
      setWeb3Modal = _useState4[1];

  var _useState5 = useState(),
      networkId = _useState5[0],
      setNetworkId = _useState5[1];

  var _useState6 = useState(),
      account = _useState6[0],
      setAccount = _useState6[1];

  var _useState7 = useState(),
      accountId = _useState7[0],
      setAccountId = _useState7[1];

  var _useState8 = useState(false),
      isInPurgatory = _useState8[0],
      setIsInPurgatory = _useState8[1];

  var _useState9 = useState(),
      purgatoryData = _useState9[0],
      setPurgatoryData = _useState9[1];

  var _useState10 = useState(initialConfig),
      config = _useState10[0],
      setConfig = _useState10[1];

  var _useState11 = useState({
    eth: undefined,
    ocean: undefined
  }),
      balance = _useState11[0],
      setBalance = _useState11[1];

  var _useState12 = useState(ProviderStatus$1.NOT_AVAILABLE),
      status = _useState12[0],
      setStatus = _useState12[1];

  var setPurgatory = useCallback(function (address) {
    try {
      if (!address) return Promise.resolve();

      var _temp2 = _catch$1(function () {
        return Promise.resolve(getAccountPurgatoryData(address)).then(function (result) {
          if ((result == null ? void 0 : result.address) !== undefined) {
            setIsInPurgatory(true);
            setPurgatoryData(result);
          } else {
            setIsInPurgatory(false);
          }

          setPurgatoryData(result);
        });
      }, function (error) {
        Logger.error(error);
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  }, []);
  var init = useCallback(function () {
    try {
      var _temp4 = function _temp4(_getDefaultProviders) {
        var web3ModalInstance = new Web3Modal(_getDefaultProviders);
        setWeb3Modal(web3ModalInstance);
        Logger.log('Web3Modal instance created.', web3ModalInstance);
      };

      Logger.log('Ocean Provider init');
      window && window.ethereum && (window.ethereum.autoRefreshOnNetworkChange = false);
      Logger.log('Web3Modal init.');
      return Promise.resolve(web3ModalOpts ? _temp4(web3ModalOpts) : Promise.resolve(getDefaultProviders()).then(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [web3ModalOpts]);
  var connect = useCallback(function (newConfig) {
    try {
      var _temp7 = _catch$1(function () {
        Logger.log('Connecting ...', newConfig);
        newConfig && setConfig(newConfig);
        return Promise.resolve(web3Modal == null ? void 0 : web3Modal.connect()).then(function (provider) {
          function _temp5(networkId) {
            setNetworkId(networkId);
            Logger.log('network id ', networkId);
            config.web3Provider = web3;
            return Promise.resolve(Ocean.getInstance(config)).then(function (ocean) {
              setOcean(ocean);
              Logger.log('Ocean instance created.', ocean);
              setStatus(ProviderStatus$1.CONNECTED);
              return Promise.resolve(ocean.accounts.list()).then(function (_ocean$accounts$list) {
                var account = _ocean$accounts$list[0];
                setAccount(account);
                Logger.log('Account ', account);
                return Promise.resolve(getAccountId(web3)).then(function (accountId) {
                  setAccountId(accountId);
                  Logger.log('account id', accountId);
                  return Promise.resolve(getBalance(account)).then(function (balance) {
                    setBalance(balance);
                    Logger.log('balance', JSON.stringify(balance));
                  });
                });
              });
            });
          }

          setWeb3Provider(provider);
          var web3 = new Web3(provider);
          setWeb3(web3);
          Logger.log('Web3 created.', web3);
          return web3 ? Promise.resolve(web3.eth.net.getId()).then(_temp5) : _temp5(web3);
        });
      }, function (error) {
        Logger.error(error);
      });

      return Promise.resolve(_temp7 && _temp7.then ? _temp7.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  }, [config, web3Modal]); // On mount setup Web3Modal instance

  useEffect(function () {
    init();
  }, [init]); // Connect automatically to cached provider if present

  useEffect(function () {
    if (!web3Modal) return;
    web3Modal.cachedProvider && connect();
  }, [web3Modal, connect]);
  useEffect(function () {
    if (!accountId) return;
    console.log('balanc ref', accountId);
    setPurgatory(accountId);
  }, [accountId]);
  useEffect(function () {
    var handleAccountsChanged = function handleAccountsChanged(accounts) {
      try {
        Logger.debug("Handling 'accountsChanged' event with payload", accounts);
        connect();
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    }; // web3Modal && web3Modal.on('connect', handleConnect)


    if (web3Provider !== undefined && web3Provider !== null) {
      web3Provider.on('accountsChanged', handleAccountsChanged); // web3Provider.on('chainChanged', handleNetworkChanged)

      return function () {
        web3Provider.removeListener('accountsChanged', handleAccountsChanged); //  web3Provider.removeListener('chainChanged', handleNetworkChanged)
      };
    }
  }, [web3Modal, web3Provider, connect]);
  return React.createElement(OceanContext.Provider, {
    value: {
      web3: web3,
      web3Provider: web3Provider,
      web3Modal: web3Modal,
      ocean: ocean,
      account: account,
      accountId: accountId,
      isInPurgatory: isInPurgatory,
      purgatoryData: purgatoryData,
      balance: balance,
      networkId: networkId,
      status: status,
      config: config,
      connect: connect,
      logout: logout,
      refreshBalance: refreshBalance
    }
  }, children);
} // Helper hook to access the provider values


var useOcean = function useOcean() {
  return useContext(OceanContext);
};

function _catch$2(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, result);
}

function useConsume() {
  var consume = function consume(did, dataTokenAddress, serviceType, marketFeeAddress, orderId) {
    if (serviceType === void 0) {
      serviceType = 'access';
    }

    try {
      if (!ocean || !account || !accountId) return Promise.resolve();
      setIsLoading(true);
      setConsumeError(undefined);

      var _temp7 = _finallyRethrows(function () {
        return _catch$2(function () {
          function _temp5() {
            function _temp3() {
              setStep(4);
            }

            setStep(3);

            var _temp2 = function () {
              if (orderId) return Promise.resolve(ocean.assets.download(did, orderId, dataTokenAddress, account, '')).then(function () {});
            }();

            return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
          }

          setStep(0);

          var _temp4 = function () {
            if (!orderId) {
              // if we don't have a previous valid order, get one
              return Promise.resolve(ocean.accounts.getTokenBalance(dataTokenAddress, account)).then(function (userOwnedTokens) {
                var _temp = function () {
                  if (parseFloat(userOwnedTokens) < 1) {
                    setConsumeError('Not enough datatokens');
                  } else {
                    setStep(1);
                    return Promise.resolve(ocean.assets.order(did, serviceType, accountId, undefined, marketFeeAddress)).then(function (_ocean$assets$order) {
                      orderId = _ocean$assets$order;
                      Logger.log('order created', orderId);
                      setStep(2);
                    });
                  }
                }();

                if (_temp && _temp.then) return _temp.then(function () {});
              });
            }
          }();

          return _temp4 && _temp4.then ? _temp4.then(_temp5) : _temp5(_temp4);
        }, function (error) {
          setConsumeError(error.message);
          Logger.error(error);
        });
      }, function (_wasThrown, _result) {
        setConsumeStep(undefined);
        setConsumeStepText(undefined);
        setIsLoading(false);
        if (_wasThrown) throw _result;
        return _result;
      });

      return Promise.resolve(_temp7 && _temp7.then ? _temp7.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var _useOcean = useOcean(),
      ocean = _useOcean.ocean,
      account = _useOcean.account,
      accountId = _useOcean.accountId;

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = useState(),
      consumeStep = _useState2[0],
      setConsumeStep = _useState2[1];

  var _useState3 = useState(),
      consumeStepText = _useState3[0],
      setConsumeStepText = _useState3[1];

  var _useState4 = useState(),
      consumeError = _useState4[0],
      setConsumeError = _useState4[1];

  function setStep(index) {
    setConsumeStep(index);
    setConsumeStepText(consumeFeedback[index]);
  }

  return {
    consume: consume,
    consumeStep: consumeStep,
    consumeStepText: consumeStepText,
    consumeError: consumeError,
    isLoading: isLoading
  };
}

function useMetadata(asset) {
  var _useOcean = useOcean(),
      ocean = _useOcean.ocean,
      config = _useOcean.config,
      status = _useOcean.status,
      networkId = _useOcean.networkId;

  var _useState = useState(),
      internalDdo = _useState[0],
      setDDO = _useState[1];

  var _useState2 = useState(),
      internalDid = _useState2[0],
      setDID = _useState2[1];

  var _useState3 = useState(),
      metadata = _useState3[0],
      setMetadata = _useState3[1];

  var _useState4 = useState(),
      title = _useState4[0],
      setTitle = _useState4[1];

  var _useState5 = useState(),
      price = _useState5[0],
      setPrice = _useState5[1];

  var _useState6 = useState(),
      owner = _useState6[0],
      setOwner = _useState6[1];

  var getDDO = useCallback(function (did, cancelToken) {
    try {
      if (!config.metadataCacheUri) return Promise.resolve();
      return Promise.resolve(axios.get(config.metadataCacheUri + "/api/v1/aquarius/assets/ddo/" + did, {
        cancelToken: cancelToken
      })).then(function (request) {
        var ddo = request.data;
        return ddo;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  }, [config.metadataCacheUri]);
  var getLivePrice = useCallback(function () {
    try {
      var _internalDdo$price;

      if (!internalDdo) return Promise.resolve({
        type: '',
        address: '',
        value: 0,
        ocean: 0,
        datatoken: 0
      });
      return Promise.resolve(getDataTokenPrice(ocean, internalDdo.dataToken, internalDdo == null ? void 0 : (_internalDdo$price = internalDdo.price) == null ? void 0 : _internalDdo$price.type, internalDdo.price.pools[0]));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [ocean, internalDdo]);
  var getMetadata = useCallback(function (ddo) {
    try {
      var _metadata = ddo.findServiceByType('metadata');

      return Promise.resolve(_metadata.attributes);
    } catch (e) {
      return Promise.reject(e);
    }
  }, []); //
  // Get and set DDO based on passed DDO or DID
  //

  useEffect(function () {
    var init = function init() {
      try {
        return Promise.resolve(function () {
          if (isDDO(asset)) {
            setDDO(asset);
            setDID(asset.id);
          } else {
            // asset is a DID
            return Promise.resolve(getDDO(asset, source.token)).then(function (ddo) {
              if (!isMounted) return;
              Logger.debug('DDO', ddo);
              setDDO(ddo);
              setDID(asset);
            });
          }
        }());
      } catch (e) {
        return Promise.reject(e);
      }
    };

    if (!asset) return;
    var source = axios.CancelToken.source();
    var isMounted = true;
    init();
    return function () {
      isMounted = false;
      source.cancel();
    };
  }, [asset, getDDO]); //
  // Get metadata & price for stored DDO
  //

  useEffect(function () {
    var init = function init() {
      try {
        if (!internalDdo) return Promise.resolve(); // Set price from DDO first

        setPrice(internalDdo.price);
        return Promise.resolve(getMetadata(internalDdo)).then(function (metadata) {
          setMetadata(metadata);
          setTitle(metadata.main.name);
          setOwner(internalDdo.publicKey[0].owner);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };

    init();
  }, [status, networkId, config, internalDdo, getMetadata]);
  return {
    ddo: internalDdo,
    did: internalDid,
    metadata: metadata,
    title: title,
    owner: owner,
    price: price,
    getLivePrice: getLivePrice
  };
}

function _settle$1(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact$1) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }

        value = value.v;
      } else {
        value.o = _settle$1.bind(null, pact, state);
        return;
      }
    }

    if (value && value.then) {
      value.then(_settle$1.bind(null, pact, state), _settle$1.bind(null, pact, 2));
      return;
    }

    pact.s = state;
    pact.v = value;
    var observer = pact.o;

    if (observer) {
      observer(pact);
    }
  }
}

var _Pact$1 = /*#__PURE__*/function () {
  function _Pact() {}

  _Pact.prototype.then = function (onFulfilled, onRejected) {
    var result = new _Pact();
    var state = this.s;

    if (state) {
      var callback = state & 1 ? onFulfilled : onRejected;

      if (callback) {
        try {
          _settle$1(result, 1, callback(this.v));
        } catch (e) {
          _settle$1(result, 2, e);
        }

        return result;
      } else {
        return this;
      }
    }

    this.o = function (_this) {
      try {
        var value = _this.v;

        if (_this.s & 1) {
          _settle$1(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle$1(result, 1, onRejected(value));
        } else {
          _settle$1(result, 2, value);
        }
      } catch (e) {
        _settle$1(result, 2, e);
      }
    };

    return result;
  };

  return _Pact;
}();

function _switch(discriminant, cases) {
  var dispatchIndex = -1;
  var awaitBody;

  outer: {
    for (var i = 0; i < cases.length; i++) {
      var test = cases[i][0];

      if (test) {
        var testValue = test();

        if (testValue && testValue.then) {
          break outer;
        }

        if (testValue === discriminant) {
          dispatchIndex = i;
          break;
        }
      } else {
        // Found the default case, set it as the pending dispatch case
        dispatchIndex = i;
      }
    }

    if (dispatchIndex !== -1) {
      do {
        var body = cases[dispatchIndex][1];

        while (!body) {
          dispatchIndex++;
          body = cases[dispatchIndex][1];
        }

        var result = body();

        if (result && result.then) {
          awaitBody = true;
          break outer;
        }

        var fallthroughCheck = cases[dispatchIndex][2];
        dispatchIndex++;
      } while (fallthroughCheck && !fallthroughCheck());

      return result;
    }
  }

  var pact = new _Pact$1();

  var reject = _settle$1.bind(null, pact, 2);

  (awaitBody ? result.then(_resumeAfterBody) : testValue.then(_resumeAfterTest)).then(void 0, reject);
  return pact;

  function _resumeAfterTest(value) {
    for (;;) {
      if (value === discriminant) {
        dispatchIndex = i;
        break;
      }

      if (++i === cases.length) {
        if (dispatchIndex !== -1) {
          break;
        } else {
          _settle$1(pact, 1, result);

          return;
        }
      }

      test = cases[i][0];

      if (test) {
        value = test();

        if (value && value.then) {
          value.then(_resumeAfterTest).then(void 0, reject);
          return;
        }
      } else {
        dispatchIndex = i;
      }
    }

    do {
      var body = cases[dispatchIndex][1];

      while (!body) {
        dispatchIndex++;
        body = cases[dispatchIndex][1];
      }

      var result = body();

      if (result && result.then) {
        result.then(_resumeAfterBody).then(void 0, reject);
        return;
      }

      var fallthroughCheck = cases[dispatchIndex][2];
      dispatchIndex++;
    } while (fallthroughCheck && !fallthroughCheck());

    _settle$1(pact, 1, result);
  }

  function _resumeAfterBody(result) {
    for (;;) {
      var fallthroughCheck = cases[dispatchIndex][2];

      if (!fallthroughCheck || fallthroughCheck()) {
        break;
      }

      dispatchIndex++;
      var body = cases[dispatchIndex][1];

      while (!body) {
        dispatchIndex++;
        body = cases[dispatchIndex][1];
      }

      result = body();

      if (result && result.then) {
        result.then(_resumeAfterBody).then(void 0, reject);
        return;
      }
    }

    _settle$1(pact, 1, result);
  }
}

function _catch$3(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _finallyRethrows$1(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, result);
}

function usePublish() {
  /**
   * Publish an asset.It also creates the datatoken, mints tokens and gives the market allowance
   * @param  {Metadata} asset The metadata of the asset.
   * @param  {PriceOptions}  priceOptions : number of tokens to mint, datatoken weight , liquidity fee, type : fixed, dynamic
   * @param  {ServiceType} serviceType Desired service type of the asset access or compute
   * @param  {DataTokenOptions} dataTokenOptions custom name, symbol and cap for datatoken
   * @return {Promise<DDO>} Returns the newly published ddo
   */
  var publish = function publish(asset, serviceType, dataTokenOptions, timeout, providerUri) {
    try {
      if (status !== ProviderStatus$1.CONNECTED || !ocean || !account) return Promise.resolve(null);
      setIsLoading(true);
      setPublishError(undefined);
      setStep(0);
      return Promise.resolve(_finallyRethrows$1(function () {
        return _catch$3(function () {
          var _interrupt;

          function _temp2() {
            Logger.log('services created', services);
            return Promise.resolve(ocean.assets.create(asset, account, services, undefined, dataTokenOptions == null ? void 0 : dataTokenOptions.cap, dataTokenOptions == null ? void 0 : dataTokenOptions.name, dataTokenOptions == null ? void 0 : dataTokenOptions.symbol, providerUri).next(setStep)).then(function (ddo) {
              Logger.log('ddo created', ddo);
              return Promise.resolve(sleep(20000)).then(function () {
                setStep(7);
                return ddo;
              });
            });
          }

          var publishedDate = new Date(Date.now()).toISOString().split('.')[0] + 'Z';
          var services = [];
          var price = '1';

          var _temp = _switch(serviceType, [[function () {
            return 'access';
          }, function () {
            {
              if (!timeout) timeout = 0;
              return Promise.resolve(ocean.assets.createAccessServiceAttributes(account, price, publishedDate, timeout, providerUri)).then(function (accessService) {
                Logger.log('access service created', accessService);
                services.push(accessService);
                _interrupt = 1;
              });
            }
          }], [function () {
            return 'compute';
          }, function () {
            {
              if (!timeout) timeout = 3600;
              var cluster = ocean.compute.createClusterAttributes('Kubernetes', 'http://10.0.0.17/xxx');
              var servers = [ocean.compute.createServerAttributes('1', 'xlsize', '50', '16', '0', '128gb', '160gb', timeout)];
              var containers = [ocean.compute.createContainerAttributes('tensorflow/tensorflow', 'latest', 'sha256:cb57ecfa6ebbefd8ffc7f75c0f00e57a7fa739578a429b6f72a0df19315deadc')];
              var provider = ocean.compute.createProviderAttributes('Azure', 'Compute service with 16gb ram for each node.', cluster, containers, servers);
              var origComputePrivacy = {
                allowRawAlgorithm: true,
                allowNetworkAccess: false,
                trustedAlgorithms: []
              };
              var computeService = ocean.compute.createComputeService(account, price, publishedDate, provider, origComputePrivacy, timeout, providerUri);
              services.push(computeService);
              _interrupt = 1;
              return;
            }
          }]]);

          return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
        }, function (error) {
          setPublishError(error.message);
          Logger.error(error);
          setStep();
        });
      }, function (_wasThrown, _result) {
        setIsLoading(false);
        if (_wasThrown) throw _result;
        return _result;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var _useOcean = useOcean(),
      ocean = _useOcean.ocean,
      status = _useOcean.status,
      account = _useOcean.account;

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = useState(),
      publishStep = _useState2[0],
      setPublishStep = _useState2[1];

  var _useState3 = useState(),
      publishStepText = _useState3[0],
      setPublishStepText = _useState3[1];

  var _useState4 = useState(),
      publishError = _useState4[0],
      setPublishError = _useState4[1];

  function setStep(index) {
    setPublishStep(index);
    index && setPublishStepText(publishFeedback[index]);
  }

  return {
    publish: publish,
    publishStep: publishStep,
    publishStepText: publishStepText,
    isLoading: isLoading,
    publishError: publishError
  };
}

function _catch$4(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var rawAlgorithmMeta = {
  rawcode: "console.log('Hello world'!)",
  format: 'docker-image',
  version: '0.1',
  container: {
    entrypoint: '',
    image: '',
    tag: ''
  }
};

function _finallyRethrows$2(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, result);
}

function useCompute() {
  var compute = function compute(did, computeService, dataTokenAddress, algorithmRawCode, computeContainer, marketFeeAddress, orderId) {
    try {
      if (!ocean || !account) return Promise.resolve();
      setComputeError(undefined);
      return Promise.resolve(_finallyRethrows$2(function () {
        return _catch$4(function () {
          function _temp3() {
            setStep(2);
            return function () {
              if (orderId) {
                return Promise.resolve(ocean.compute.start(did, orderId, dataTokenAddress, account, undefined, rawAlgorithmMeta, output, "" + computeService.index, computeService.type));
              }
            }();
          }

          setIsLoading(true);
          setStep(0);
          rawAlgorithmMeta.container = computeContainer;
          rawAlgorithmMeta.rawcode = algorithmRawCode;
          var output = {};

          var _temp2 = function () {
            if (!orderId) {
              return Promise.resolve(ocean.accounts.getTokenBalance(dataTokenAddress, account)).then(function (userOwnedTokens) {
                var _temp = function () {
                  if (parseFloat(userOwnedTokens) < 1) {
                    setComputeError('Not enough datatokens');
                  } else {
                    Logger.log('compute order', accountId, did, computeService, rawAlgorithmMeta, marketFeeAddress);
                    return Promise.resolve(ocean.compute.order(accountId, did, computeService.index, undefined, rawAlgorithmMeta, marketFeeAddress)).then(function (_ocean$compute$order) {
                      orderId = _ocean$compute$order;
                      setStep(1);
                    });
                  }
                }();

                if (_temp && _temp.then) return _temp.then(function () {});
              });
            }
          }();

          return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
        }, function (error) {
          Logger.error(error);
          setComputeError(error.message);
        });
      }, function (_wasThrown, _result2) {
        setStep(undefined);
        setIsLoading(false);
        if (_wasThrown) throw _result2;
        return _result2;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var _useOcean = useOcean(),
      ocean = _useOcean.ocean,
      account = _useOcean.account,
      accountId = _useOcean.accountId;

  var _useState = useState(),
      computeStep = _useState[0],
      setComputeStep = _useState[1];

  var _useState2 = useState(),
      computeStepText = _useState2[0],
      setComputeStepText = _useState2[1];

  var _useState3 = useState(),
      computeError = _useState3[0],
      setComputeError = _useState3[1];

  var _useState4 = useState(false),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  function setStep(index) {
    if (!index) {
      setComputeStep(undefined);
      setComputeStepText(undefined);
      return;
    }

    setComputeStep(index);
    setComputeStepText(computeFeedback[index]);
  }

  return {
    compute: compute,
    computeStep: computeStep,
    computeStepText: computeStepText,
    computeError: computeError,
    isLoading: isLoading
  };
}

var computeOptions = [{
  name: 'nodejs',
  value: {
    entrypoint: 'node $ALGO',
    image: 'node',
    tag: '10'
  }
}, {
  name: 'python3.7',
  value: {
    entrypoint: 'python $ALGO',
    image: 'oceanprotocol/algo_dockers',
    tag: 'python-panda'
  }
}];

function _settle$2(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact$2) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }

        value = value.v;
      } else {
        value.o = _settle$2.bind(null, pact, state);
        return;
      }
    }

    if (value && value.then) {
      value.then(_settle$2.bind(null, pact, state), _settle$2.bind(null, pact, 2));
      return;
    }

    pact.s = state;
    pact.v = value;
    var observer = pact.o;

    if (observer) {
      observer(pact);
    }
  }
}

var _Pact$2 = /*#__PURE__*/function () {
  function _Pact() {}

  _Pact.prototype.then = function (onFulfilled, onRejected) {
    var result = new _Pact();
    var state = this.s;

    if (state) {
      var callback = state & 1 ? onFulfilled : onRejected;

      if (callback) {
        try {
          _settle$2(result, 1, callback(this.v));
        } catch (e) {
          _settle$2(result, 2, e);
        }

        return result;
      } else {
        return this;
      }
    }

    this.o = function (_this) {
      try {
        var value = _this.v;

        if (_this.s & 1) {
          _settle$2(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle$2(result, 1, onRejected(value));
        } else {
          _settle$2(result, 2, value);
        }
      } catch (e) {
        _settle$2(result, 2, e);
      }
    };

    return result;
  };

  return _Pact;
}();

function _switch$1(discriminant, cases) {
  var dispatchIndex = -1;
  var awaitBody;

  outer: {
    for (var i = 0; i < cases.length; i++) {
      var test = cases[i][0];

      if (test) {
        var testValue = test();

        if (testValue && testValue.then) {
          break outer;
        }

        if (testValue === discriminant) {
          dispatchIndex = i;
          break;
        }
      } else {
        // Found the default case, set it as the pending dispatch case
        dispatchIndex = i;
      }
    }

    if (dispatchIndex !== -1) {
      do {
        var body = cases[dispatchIndex][1];

        while (!body) {
          dispatchIndex++;
          body = cases[dispatchIndex][1];
        }

        var result = body();

        if (result && result.then) {
          awaitBody = true;
          break outer;
        }

        var fallthroughCheck = cases[dispatchIndex][2];
        dispatchIndex++;
      } while (fallthroughCheck && !fallthroughCheck());

      return result;
    }
  }

  var pact = new _Pact$2();

  var reject = _settle$2.bind(null, pact, 2);

  (awaitBody ? result.then(_resumeAfterBody) : testValue.then(_resumeAfterTest)).then(void 0, reject);
  return pact;

  function _resumeAfterTest(value) {
    for (;;) {
      if (value === discriminant) {
        dispatchIndex = i;
        break;
      }

      if (++i === cases.length) {
        if (dispatchIndex !== -1) {
          break;
        } else {
          _settle$2(pact, 1, result);

          return;
        }
      }

      test = cases[i][0];

      if (test) {
        value = test();

        if (value && value.then) {
          value.then(_resumeAfterTest).then(void 0, reject);
          return;
        }
      } else {
        dispatchIndex = i;
      }
    }

    do {
      var body = cases[dispatchIndex][1];

      while (!body) {
        dispatchIndex++;
        body = cases[dispatchIndex][1];
      }

      var result = body();

      if (result && result.then) {
        result.then(_resumeAfterBody).then(void 0, reject);
        return;
      }

      var fallthroughCheck = cases[dispatchIndex][2];
      dispatchIndex++;
    } while (fallthroughCheck && !fallthroughCheck());

    _settle$2(pact, 1, result);
  }

  function _resumeAfterBody(result) {
    for (;;) {
      var fallthroughCheck = cases[dispatchIndex][2];

      if (!fallthroughCheck || fallthroughCheck()) {
        break;
      }

      dispatchIndex++;
      var body = cases[dispatchIndex][1];

      while (!body) {
        dispatchIndex++;
        body = cases[dispatchIndex][1];
      }

      result = body();

      if (result && result.then) {
        result.then(_resumeAfterBody).then(void 0, reject);
        return;
      }
    }

    _settle$2(pact, 1, result);
  }
}

function _catch$5(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _finallyRethrows$3(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, result);
}

function usePricing(ddo) {
  var createPricing = function createPricing(priceOptions) {
    try {
      if (!ocean || !accountId || !dtSymbol) return Promise.resolve();
      var type = priceOptions.type,
          oceanAmount = priceOptions.oceanAmount,
          price = priceOptions.price,
          weightOnDataToken = priceOptions.weightOnDataToken,
          swapFee = priceOptions.swapFee;
      var dtAmount = priceOptions.dtAmount;
      var isPool = type === 'dynamic';

      if (!isPool && !config.fixedRateExchangeAddress) {
        Logger.error("'fixedRateExchangeAddress' not set in config.");
        return Promise.resolve();
      }

      setPricingIsLoading(true);
      setPricingError(undefined);
      setStep(99, 'pool');
      return Promise.resolve(_finallyRethrows$3(function () {
        return _catch$5(function () {
          // if fixedPrice set dt to max amount
          if (!isPool) dtAmount = 1000;
          return Promise.resolve(mint("" + dtAmount)).then(function () {
            // dtAmount for fixed price is set to max
            return Promise.resolve(isPool ? ocean.pool.create(accountId, dataToken, "" + dtAmount, weightOnDataToken, "" + oceanAmount, swapFee).next(function (step) {
              return setStep(step, 'pool');
            }) : ocean.fixedRateExchange.create(dataToken, "" + price, accountId, "" + dtAmount).next(function (step) {
              return setStep(step, 'exchange');
            })).then(function (tx) {
              return Promise.resolve(sleep(20000)).then(function () {
                return tx;
              });
            });
          });
        }, function (error) {
          setPricingError(error.message);
          Logger.error(error);
        });
      }, function (_wasThrown3, _result4) {
        setPricingStep(0);
        setPricingStepText(undefined);
        setPricingIsLoading(false);
        if (_wasThrown3) throw _result4;
        return _result4;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var sellDT = function sellDT(dtAmount) {
    try {
      if (!ocean || !accountId) return Promise.resolve();

      if (!config.oceanTokenAddress) {
        Logger.error("'oceanTokenAddress' not set in config");
        return Promise.resolve();
      }

      return Promise.resolve(_finallyRethrows$3(function () {
        return _catch$5(function () {
          setPricingIsLoading(true);
          setPricingError(undefined);
          setStep(1, 'sell');
          return Promise.resolve(getFirstPool(ocean, dataToken)).then(function (pool) {
            if (!pool || pool.price === 0) return;
            var price = new Decimal(pool.price).times(0.95).toString();
            setStep(2, 'sell');
            Logger.log('Selling token to pool', pool, accountId, price);
            return Promise.resolve(ocean.pool.sellDT(accountId, pool.address, "" + dtAmount, price)).then(function (tx) {
              setStep(3, 'sell');
              Logger.log('DT sell response', tx);
              return tx;
            });
          });
        }, function (error) {
          setPricingError(error.message);
          Logger.error(error);
        });
      }, function (_wasThrown2, _result3) {
        setStep(0, 'sell');
        setPricingStepText(undefined);
        setPricingIsLoading(false);
        if (_wasThrown2) throw _result3;
        return _result3;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var buyDT = function buyDT(dtAmount) {
    try {
      var _exit2;

      if (!ocean || !accountId) return Promise.resolve();
      var tx;

      var _temp5 = _finallyRethrows$3(function () {
        return _catch$5(function () {
          setPricingIsLoading(true);
          setPricingError(undefined);
          setStep(1, 'buy');
          return Promise.resolve(getBestDataTokenPrice(ocean, dataToken)).then(function (bestPrice) {
            return _switch$1(bestPrice == null ? void 0 : bestPrice.type, [[function () {
              return 'pool';
            }, function () {
              {
                var price = new Decimal(bestPrice.value).times(1.05).toString();
                var maxPrice = new Decimal(bestPrice.value).times(2).toString();
                setStep(2, 'buy');
                Logger.log('Buying token from pool', bestPrice, accountId, price);
                return Promise.resolve(ocean.pool.buyDT(accountId, bestPrice.address, String(dtAmount), price, maxPrice)).then(function (_ocean$pool$buyDT) {
                  tx = _ocean$pool$buyDT;
                  setStep(3, 'buy');
                  Logger.log('DT buy response', tx);
                });
              }
            }], [function () {
              return 'exchange';
            }, function () {
              {
                if (!config.oceanTokenAddress) {
                  Logger.error("'oceanTokenAddress' not set in config");
                  _exit2 = 1;
                  return;
                }

                if (!config.fixedRateExchangeAddress) {
                  Logger.error("'fixedRateExchangeAddress' not set in config");
                  _exit2 = 1;
                  return;
                }

                Logger.log('Buying token from exchange', bestPrice, accountId);
                return Promise.resolve(ocean.datatokens.approve(config.oceanTokenAddress, config.fixedRateExchangeAddress, "" + bestPrice.value, accountId)).then(function () {
                  setStep(2, 'buy');
                  return Promise.resolve(ocean.fixedRateExchange.buyDT(bestPrice.address, "" + dtAmount, accountId)).then(function (_ocean$fixedRateExcha) {
                    tx = _ocean$fixedRateExcha;
                    setStep(3, 'buy');
                    Logger.log('DT exchange buy response', tx);
                  });
                });
              }
            }]]);
          });
        }, function (error) {
          setPricingError(error.message);
          Logger.error(error);
        });
      }, function (_wasThrown, _result) {
        setStep(0, 'buy');
        setPricingStepText(undefined);
        setPricingIsLoading(false);
        if (_wasThrown) throw _result;
        return _result;
      });

      return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function (_result) {
        return _exit2 ? _result : tx;
      }) : _exit2 ? _temp5 : tx);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var mint = function mint(tokensToMint) {
    try {
      Logger.log('mint function', dataToken, accountId);
      return Promise.resolve(ocean.datatokens.balance(dataToken, accountId)).then(function (_ocean$datatokens$bal) {
        var balance = new Decimal(_ocean$datatokens$bal);
        var tokens = new Decimal(tokensToMint);
        return function () {
          if (tokens.greaterThan(balance)) {
            var mintAmount = tokens.minus(balance);
            return Promise.resolve(ocean.datatokens.mint(dataToken, accountId, mintAmount.toString()));
          }
        }();
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var _useOcean = useOcean(),
      ocean = _useOcean.ocean,
      accountId = _useOcean.accountId,
      config = _useOcean.config;

  var _useState = useState(false),
      pricingIsLoading = _useState[0],
      setPricingIsLoading = _useState[1];

  var _useState2 = useState(),
      pricingStep = _useState2[0],
      setPricingStep = _useState2[1];

  var _useState3 = useState(),
      pricingStepText = _useState3[0],
      setPricingStepText = _useState3[1];

  var _useState4 = useState(),
      pricingError = _useState4[0],
      setPricingError = _useState4[1];

  var _useState5 = useState(),
      dtSymbol = _useState5[0],
      setDtSymbol = _useState5[1];

  var _useState6 = useState(),
      dtName = _useState6[0],
      setDtName = _useState6[1];

  var dataToken = ddo.dataToken,
      dataTokenInfo = ddo.dataTokenInfo; // Get Datatoken info, from DDO first, then from chain

  useEffect(function () {
    var init = function init() {
      try {
        var _temp3 = function _temp3(dtSymbol) {
          function _temp(dtName) {
            setDtName(dtName);
          }

          setDtSymbol(dtSymbol);
          return dataTokenInfo ? _temp(dataTokenInfo.name) : Promise.resolve(ocean == null ? void 0 : ocean.datatokens.getName(dataToken)).then(_temp);
        };

        return Promise.resolve(dataTokenInfo ? _temp3(dataTokenInfo.symbol) : Promise.resolve(ocean == null ? void 0 : ocean.datatokens.getSymbol(dataToken)).then(_temp3));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    if (!dataToken) return;
    init();
  }, [ocean, dataToken, dataTokenInfo]); // Helper for setting steps & feedback for all flows

  function setStep(index, type) {
    setPricingStep(index);
    if (!dtSymbol) return;
    var messages;

    switch (type) {
      case 'pool':
        messages = getCreatePricingPoolFeedback(dtSymbol);
        break;

      case 'exchange':
        messages = getCreatePricingExchangeFeedback(dtSymbol);
        break;

      case 'buy':
        messages = getBuyDTFeedback(dtSymbol);
        break;

      case 'sell':
        messages = getSellDTFeedback(dtSymbol);
        break;
    }

    setPricingStepText(messages[index]);
  }

  return {
    dtSymbol: dtSymbol,
    dtName: dtName,
    createPricing: createPricing,
    buyDT: buyDT,
    sellDT: sellDT,
    mint: mint,
    pricingStep: pricingStep,
    pricingStepText: pricingStepText,
    pricingIsLoading: pricingIsLoading,
    pricingError: pricingError
  };
}

export { OceanContext, OceanProvider, computeFeedback, computeOptions, consumeFeedback, feedback, getAccountId, getBalance, getBestDataTokenPrice, getBuyDTFeedback, getCheapestExchange, getCheapestPool, getCreatePricingExchangeFeedback, getCreatePricingPoolFeedback, getDataTokenPrice, getFirstExchange, getFirstPool, getSellDTFeedback, isDDO, publishFeedback, readFileContent, sleep, useCompute, useConsume, useMetadata, useOcean, usePricing, usePublish };